import { connect } from "react-redux";
import { showLoading } from "../../actions/loaderAction";
import DropDown from "../DropDown";
import { useEffect, useState } from "react";
import ButtonAdminpanel from "../ButtonAdminpanel";
import { isEmpty } from "lodash";

const UserFilter = ({ onFilterChange, resetFilterFlag }) => {
  const [findByOptionVal, setFindByOptionVal] = useState();

  const findByOptions = [
    {
      label: "Buyer",
      value: "BUYER",
    },
    {
      label: "Supplier",
      value: "SUPPLIER",
    },
    {
      label: "Logistic Partner",
      value: "LOG_PTR",
    },
  ];

  const handleFindByChange = (val) => {
    setFindByOptionVal(val);
  };

  const filterUsers = () => {
    if (!isEmpty(findByOptionVal)) {
        onFilterChange(findByOptionVal);
    } else {
        onFilterChange(null);
    }
    
  }

  const resetFilter = () => {
    setFindByOptionVal(null);
    onFilterChange(null);
  }

  useEffect(() => {
    if (resetFilterFlag == true) {
        setFindByOptionVal(null);
    }
  }, [resetFilterFlag]);

  return (
    <div className="bg-white shadow rounded p-4 mb-4">
      <div className="row ">
        <div className="col-md-6 col-xxl-3 col-lg-6 my-1">
          <DropDown
            placeholder="Select.."
            options={findByOptions}
            value={findByOptionVal}
            onChange={handleFindByChange}
          />
        </div>
        <div className="filter-search-btn col-xl-4 col-md-6 d-flex align-items-center mt-2">
          <div className="d-flex align-items-center">
          <ButtonAdminpanel
            type="button"
            onClick={filterUsers}
            className="btn-regi"
          >
            {" "}
            <i className="fa-solid fa-magnifying-glass text-white"></i> Search{" "}
          </ButtonAdminpanel>
          <button type="button" className=" btn filter-reset-btn mx-2" onClick={resetFilter}>
                            <svg viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fillRule="evenodd" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" transform="matrix(0 1 1 0 2.5 2.5)"> <path d="m3.98652376 1.07807068c-2.38377179 1.38514556-3.98652376 3.96636605-3.98652376 6.92192932 0 4.418278 3.581722 8 8 8s8-3.581722 8-8-3.581722-8-8-8"></path> <path d="m4 1v4h-4" transform="matrix(1 0 0 -1 0 6)"></path> </g> </g></svg>
                            Reset</button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    showLoading: () => dispatch(showLoading()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserFilter);
